import Vue from 'vue'
import Router from 'vue-router'
import pcRoute from './pc'
import mobileRoute from './mobile'
import utils from './../utils/index'
Vue.use(Router)

const router = new Router({
  routes: utils.isMobileEnv ? mobileRoute : pcRoute
})
function isMobile () {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag
}
// 清除移动端微信分享时链接带上微信标识参数
router.beforeEach((to, from, next) => {
  /**
   * 剔除微信在url中自动添加的参数
   */
  if (location.href.indexOf('from=singlemessage') > -1 || location.href.indexOf('from=groupmessage') > -1 || location.href.indexOf('from=timeline') > -1 || location.href.indexOf('isappinstalled=0') > -1) {
    // 定义页面路径
    let pagePath = `index.html#${to.path}`
    if (JSON.stringify(to.query) !== '{}') {
      // 重组url参数
      pagePath = pagePath + '?'
      const queryKeyArr = Object.keys(to.query)
      queryKeyArr.forEach((key, index) => {
        if (index === 0) {
          pagePath += key + '=' + to.query[key]
        } else {
          pagePath += '&' + key + '=' + to.query[key]
        }
      })
    }
    // 替换页面路径
    history.replaceState(null, null, pagePath)
    next()
  } else {
    next()
  }
  if (!utils.isMobileEnv) {
    if (isMobile()) {
      window.location.href = 'https://m.zhengpin.so/#/'
    }
    next()
  }
})
router.afterEach((to, from, next) => {
  // 移动端title
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  // 页面恢复到顶部位置
  scrollTo(0, 0)

  // 隐藏微信底部菜单
  function onBridgeReady () {
    window.WeixinJSBridge.call('hideOptionMenu')
  }
  // 隐藏微信自带底部菜单
  if (typeof WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
    }
  } else {
    onBridgeReady()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js